import NB_EXT_1 from "./NB_EXT_1";
import NB_EXT_2 from "./NB_EXT_2";
export default {
  NB_EXT_1,
  NB_EXT_2,
};
